import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { api, imgUrl, formatApiError } from "../../../lib/api";
import { Card } from "../AdminUI";
import { VARIANTS } from "./igUtils";

export function SourcePicker({ onCreated }) {
  const [sources, setSources] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/admin/instagram/sources").then((r) => setSources(r.data)).catch(() => setSources([])); }, []);

  const generate = async (s) => {
    const key = `${s.source_type}:${s.source_id}:${s.variant}`;
    setBusy(key);
    try {
      const { data } = await api.post("/admin/instagram/generate", { source_type: s.source_type, source_id: s.source_id, variant: s.variant });
      toast.success("Bozza creata: controlla anteprima e didascalia");
      onCreated(data);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(""); }
  };

  if (!sources) return <Card className="text-sm text-stone">Caricamento contenuti…</Card>;
  return (
    <Card data-testid="ig-sources">
      <h2 className="text-sm font-medium mb-1">Genera un post dai contenuti del sito</h2>
      <p className="text-xs text-stone mb-4">Ogni immagine viene incorniciata nel formato Home Haven 1080×1350 con logo ed etichette Prima/Dopo. La didascalia usa solo dati già pubblicati.</p>
      {sources.length === 0 && <div className="text-sm text-stone">Nessun contenuto pubblicato con immagini.</div>}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
        {sources.map((s) => {
          const key = `${s.source_type}:${s.source_id}:${s.variant}`;
          return (
            <div key={key} data-testid={`ig-source-${s.variant}-${s.source_id}`} className="flex gap-3 items-center border border-gray-200 rounded-md p-2">
              <img src={imgUrl(s.image)} alt="" className="w-14 h-14 object-cover rounded" />
              <div className="flex-1 min-w-0">
                <div className="text-sm truncate">{s.title}</div>
                <div className="text-[11px] text-stone">{VARIANTS[s.variant]}{s.subtitle ? ` · ${s.subtitle}` : ""}{s.used && <span className="ml-1 text-amber-700">· già {s.used === "published" ? "pubblicato" : "in coda"}</span>}</div>
              </div>
              <button type="button" onClick={() => generate(s)} disabled={!!busy} data-testid={`ig-generate-${s.variant}-${s.source_id}`} className="btn-outline !py-1.5 !px-3 text-xs disabled:opacity-50"><Sparkles size={12} /> {busy === key ? "Creo…" : "Genera"}</button>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
